<template>
  <div :class="$style.base">
    <div v-if="company.settings.allow_month_view" :class="$style.tabs">
      <div
        :class="$style.viewOption"
        :style="selectedViewOption === 'week' && selectedStyle"
        @click="selectedViewOption = 'week'"
        v-test="'week-view-option'"
      >
        <div :class="$style.viewOptionLabel">
          {{ $t('general.week') }}
        </div>
      </div>
      <div
        :class="$style.viewOption"
        :style="selectedViewOption === 'month' && selectedStyle"
        @click="selectedViewOption = 'month'"
        v-test="'month-view-option'"
      >
        <div :class="$style.viewOptionLabel">
          {{ $t('general.month') }}
        </div>
      </div>
    </div>
    <WeekView
      v-if="selectedViewOption === 'week'"
      @loadAvailabilityData="loadAvailabilityData"
    />
    <MonthView
      v-if="selectedViewOption === 'month'"
      @loadAvailabilityData="(range: number) => loadAvailabilityData(range)"
    />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { ref, watch } from 'vue';

import { useAvailabilityStore } from '@/stores/availability';
import { useCompanyStore } from '@/stores/company';
import widgetSettings from '@/widget-settings';

import { useBookingStore } from '@/stores/booking';
import MonthView from './MonthView.vue';
import WeekView from './WeekView.vue';

const { company } = useCompanyStore();

const selectedViewOption = ref<'week' | 'month'>('week');

const selectedStyle = {
  color: widgetSettings.color,
  'box-shadow': `0px -2px 0px 0px ${widgetSettings.color} inset`
};
const { fetchAvailabilities } = useAvailabilityStore();
const { loadingAvailability, isAllDataLoaded: isAllAvailabilityDataLoaded } =
  storeToRefs(useAvailabilityStore());

const loadAvailabilityData = (range?: number) => {
  if (isAllAvailabilityDataLoaded.value) {
    return;
  }

  loadingAvailability.value = true;
  fetchAvailabilities(range).finally(() => {
    loadingAvailability.value = false;
  });
};

loadAvailabilityData();
</script>

<style lang="scss" module>
.base {
  padding: $spacing 0;
}
.tabs {
  display: flex;
  padding: 0px 16px;
  align-items: flex-start;
  align-self: stretch;
}

.viewOption {
  cursor: pointer;
  display: flex;
  padding: 10px 0px;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
}

.viewOptionLabel {
  text-align: center;
  font-size: 16px;
  font-weight: 700;
}
</style>
